export default function InstallationServices() {
  const services = [
    'Brake Installation',
    'Suspension Repairs',
    'Wheel Bearing Replacement',
    'General Mechanical Work',
    'Diagnostics'
  ];

  return (
    <section id="services" className="py-20 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <h2 className="font-rajdhani font-bold text-4xl md:text-5xl text-white mb-6">
              Professional Installation You Can Trust
            </h2>
            <p className="text-white/70 text-lg mb-8 leading-relaxed">
              Our experienced technicians provide reliable installation services so you don't have to worry about the job being done right.
            </p>

            <ul className="space-y-4 mb-10">
              {services.map((service, index) => (
                <li key={index} className="flex items-center gap-4">
                  <div className="w-8 h-8 flex items-center justify-center bg-red-600 rounded-full flex-shrink-0">
                    <i className="ri-check-line text-white text-lg"></i>
                  </div>
                  <span className="text-white font-medium text-lg">{service}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.dispatchEvent(new Event('click'))}
              className="inline-flex items-center gap-3 bg-white hover:bg-red-600 text-black hover:text-white px-8 py-4 rounded-full font-rajdhani font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Book Your Appointment Today
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>

          <div className="lg:col-span-3">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/486786f56a0ec51d95711f84c29de4df.jpg"
                alt="Professional Installation Services"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
